.maskedInput {
	padding: 0px !important;
	height: 30.7px !important;
	text-align: center !important;
}

.mainForm {
	margin-top: 10px !important;
}
